import formatCamelCase from "./formatCamelCase";

const formatCategoryLabel = (cartItem) => {
  if (!cartItem) return "";

  if (cartItem.category === "patisserie") {
    return formatCamelCase(cartItem.subcategory || "");
  }

  return formatCamelCase(cartItem.category);
};

export default formatCategoryLabel;
